module.exports = __webpack_public_path__ + "img/all_pieces_icon.189803ef.png";